import { Skeleton } from "../ui/skeleton";
import { Container } from "./Container";

export const MainLoader = () => (
  <Container>
    <Skeleton className="mx-auto h-[100vh] w-full bg-gray-100"></Skeleton>
  </Container>
);
